import React from 'react'
import { Card, Button, Col, Row } from 'antd'
import './style.less'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { ComplianceType } from '../../constants'

const PreviewCompliance = ({ qcPlanDetail }: { qcPlanDetail: AIQualityCheckPlanDetailItem | null }) => {
  return (
    <div className="scheme-preview-compliance-container">
      <Row className="node-container">
        <Col span={2}>
          <h4 className="node-label">
            板块:
          </h4>
        </Col>
        <Col span={21}>
          <span className="node-value">合规板块</span>
        </Col>
      </Row>
      {qcPlanDetail?.items?.map((item, index) => (
        <Row key={index} className="rule-container">
          <Col span={2}>
            <h4 className="node-label" style={{ marginTop: 6 }}>
              规则{index + 1}:
            </h4>
          </Col>
          <Col span={21}>
            <div className="rule-content">
              <h4>
                {item?.name}
              </h4>
              <ul className="rule-list">
                {item?.subItems?.map((subItem, subIndex) => (
                  <li key={subIndex}>
                    <p>
                      {subItem?.description}
                      <span className={`rule-status-${subItem?.complianceType === ComplianceType.violation ? 'violation' : 'exemption'}`}>({subItem?.complianceType === ComplianceType.violation ? '违规' : '豁免'})</span>
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      ))}
    </div>
  )
}

export default PreviewCompliance
